import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <div className="theme-toggle-container">
      {/* Sun icon for light mode */}
      <span className={`theme-icon ${isDarkMode ? 'opacity-50' : 'opacity-100'}`}>
        <span role="img" aria-label="Sun">☀️</span>
      </span>
      
      {/* Toggle switch */}
      <button
        onClick={toggleTheme}
        className="theme-toggle-button"
        style={{ 
          backgroundColor: isDarkMode ? '#1f2937' : '#fbbf24',
          borderColor: isDarkMode ? '#374151' : '#f59e0b'
        }}
        role="switch"
        aria-checked={isDarkMode}
        aria-label="Toggle dark mode"
      >
        <span
          className="theme-toggle-slider"
          style={{ 
            backgroundColor: isDarkMode ? '#374151' : '#ffffff',
            borderColor: isDarkMode ? '#4b5563' : '#e5e7eb',
            transform: isDarkMode ? 'translateX(24px)' : 'translateX(2px)'
          }}
        >
          <span className="theme-icon">
            {isDarkMode ? <span role="img" aria-label="Moon">🌙</span> : <span role="img" aria-label="Sun">☀️</span>}
          </span>
        </span>
      </button>
      
      {/* Moon icon for dark mode */}
      <span className={`theme-icon ${isDarkMode ? 'opacity-100' : 'opacity-50'}`}>
        <span role="img" aria-label="Moon">🌙</span>
      </span>
    </div>
  );
};

export default ThemeToggle;
